// =============================================================================
// EventBus event registry
// =============================================================================
//
// Single source of truth for cross-component signals. The bus is for
// "decoupled parts of the page reacting to a shared moment" — not a data store
// (see src/js/README.md). One name per event, grouped by domain, payload shape
// documented inline so consumers know what they receive.
//
// Add a constant here BEFORE emitting/listening to a new event: in debug mode
// the bus warns on any name not found in this registry (see smpl-components.js
// `_assertKnown`).

export const Events = Object.freeze({
	// Page lifecycle
	PAGE_RESIZE: 'page:resize', // payload: {} — debounced viewport change
	PAGE_READY: 'page:ready', // payload: visit — fired after a Swup page:view settles

	// App reveal (loader mask → page entrance; see reveal-controller.js)
	APP_REVEAL_START: 'app:reveal:start', // payload: { entry } — mask begins clearing / entrance begins
	APP_REVEAL_COMPLETE: 'app:reveal:complete', // payload: { entry } — mask fully gone, page visible

	// Swup navigation
	SWUP_CONTENT_REPLACE: 'swup:content:replace', // payload: {} — new DOM in place after a swap
	SWUP_PAGE_VIEW: 'swup:page:view', // payload: visit — Swup page:view hook
	SWUP_LINK_SELF: 'swup:link:self', // payload: visit — click on a link to the current URL

	// ScrollTrigger
	SCROLLTRIGGER_CREATED: 'scrolltrigger:created', // payload: instance — framework hook point (no default listener)

	// Scallop layers
	SCALLOP_RESTACK: 'scallop:restack', // payload: {} — a scallop layer's DOM changed; re-assign stacking z-index

	// Configurator
	CONFIGURATOR_ACTIVE_CHANGE: 'configurator:active-change', // payload: state — configurator open/close state changed

	// Overlay
	OVERLAY_CONTENT_REPLACE: 'overlay:content:replace', // payload: {} — overlay swapped its inner content

	// Filters
	FILTERS_CLEAR: 'filters:clear', // payload: {} — request to reset all active filters
})
